import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../Services/category';
import { Category } from '../Models/category';

@Component({
  selector: 'list-categories',
  templateUrl: '../Templates/category.list.html',
})

export class CategoryListComponent implements OnInit {

  categories: Category[];

  constructor(private categoryService: CategoryService) { }

  getCategories(): void {
    this.categoryService.list()
    .subscribe(data => this.categories = data['results'])
  }

  ngOnInit() {
    this.getCategories();
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/category.list.ts